export default "__VITE_ASSET__CuuRJAuz__"